import { render, staticRenderFns } from "./AccountSetting.vue?vue&type=template&id=8ed1ea5c&scoped=true&"
import script from "./AccountSetting.vue?vue&type=script&lang=js&"
export * from "./AccountSetting.vue?vue&type=script&lang=js&"
import style0 from "./AccountSetting.vue?vue&type=style&index=0&id=8ed1ea5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed1ea5c",
  null
  
)

export default component.exports